<script setup lang="ts">
import { faClock } from '@fortawesome/pro-solid-svg-icons';
import { filterXSS } from 'xss';
import { useData } from '../../_composables/useData';
import ExpandableCard from '@components/util/ExpandableCard.vue';

const { hotelPackage, title } = useData();
const { isMobile } = useSize();
const terms = computed(() => filterXSS(hotelPackage.value.termsAndConditions));
</script>
<template>
    <div id="rules" class="section-container">
        <mr-typography size="x-large" weight="700" type="h3" class="title">
            قوانین و مقررات {{ title }}
        </mr-typography>
        <ExpandableCard
            :data-value="terms"
            :default-height="isMobile ? 252 : 185"
        >
            <div class="rules-content">
                <div class="times">
                    <mr-input
                        :model-value="hotelPackage.checkinHour"
                        label="ساعت ورود"
                        readonly
                        class="time"
                        :icon="faClock"
                        hide-description
                        required
                    />
                    <mr-input
                        :model-value="hotelPackage.checkoutHour"
                        label="ساعت خروج"
                        readonly
                        class="time"
                        :icon="faClock"
                        hide-description
                        required
                    />
                </div>
                <client-only>
                    <mr-typography
                        color="var(--cool-gray-800)"
                        white-space="pre-line"
                        v-html="terms"
                    />
                </client-only>
            </div>
        </ExpandableCard>
    </div>
</template>
<style scoped lang="scss">
.title {
    margin-bottom: 8px;
    margin-top: 0;
    @include mobile-only {
        margin-bottom: 0;
    }
}
.rules-content {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    @include mobile-only {
        gap: 8px;
        flex-wrap: wrap;
    }
    .times {
        display: flex;
        align-items: center;
        gap: 8px;
        .time {
            width: 92px;
            @include mobile-only {
                width: calc(50% - 4px);
            }
        }
    }
}
</style>
